
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-end justify-end">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/61b9d392f4277e4e8d5d5f1c73249eb4.jpeg"
            alt="Hero Background"
            className="w-full h-full object-cover object-top"
          />
        </div>
        
        <div className="relative z-10 text-right px-12 pb-24 max-w-4xl">
          <h1 className="text-6xl md:text-8xl font-light text-white mb-6 tracking-tight">
            Pamela Stovall
          </h1>
          <p className="text-2xl md:text-3xl text-white font-light tracking-wide">
            Award-winning Screenwriter & Author
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
